/*
 * @Description: 优惠券列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-06-28 10:04:15
 * @LastEditors: Please set LastEditors
 */

import React, {useRef} from 'react';
import {Divider, message, Popconfirm, Select} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, post} from '../../axios';
import {formatTime} from '../../utils/index'
 import ListAdd from './components/ListAdd';
import ListCopy from './components/ListCopy';
import PayorderDetailListModal from "./components/PayorderDetailListModal";
import {
    dicClrgRuleType,
    hsbPayClrgRuleStatus,
    dicExecutionCycle
} from "../../axios/dictionaries";
import HsbMarketPlatformRuleDetail from "../HsbMarketPlatform/rule/detail";
import ActionRecords from "../ActionRecords";
import {
    API_merchant_findAll,
    API_Merchant_findHsbPayChannelConfigAll,
} from "../../axios/config";


export default class Page extends React.Component {



    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
                payType:'',
                mustPayDate:''
            },
            hsbPayChannelList:[],
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //显示新增/编辑,
            showCopyModal:false,
            actionVisible:false
        }
    }


    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
            showCopyModal,
            actionVisible
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="j-6-1" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.ListAddRef.initPack(); }}>分账规则新增</AuthButton>
                        <AuthButton authkey="j-6-6" type="primary" icon="plus" onClick={() => { this.setState({ showCopyModal: true }); this.ListCopyRef.initPack(); }}>分账规则复制</AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ handleEdit: this.handleEdit,handleEditStatus:this.handleEditStatus,handleDelete:this.handleDelete,
                        handlePayorderDetailListRef:this.handlePayorderDetailListRef,handleHsbMarketPlatformRuleDetailRef:this.handleHsbMarketPlatformRuleDetailRef,handleQueryActionRecords:this.handleQueryActionRecords})}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
                <ListAdd
                    onRef={ref => this.ListAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <ListCopy
                    onRef={ref => this.ListCopyRef = ref}
                    visible={showCopyModal}
                    handleCancel={() => { this.setState({ showCopyModal: false }) }}
                    handleGetList={this.handleSearch}
                >

                </ListCopy>
                <PayorderDetailListModal ref={ref => { this.PayorderDetailListModalRef = ref }} />
                <HsbMarketPlatformRuleDetail getRef={ref => this.HsbMarketPlatformRuleDetailRef = ref} />
                <ActionRecords
                    onRef={ref => this.onAction = ref}
                    visible={actionVisible}
                    handleCancel={() => { this.setState({ actionVisible: false }) }}
                />
            </PageWrap>
        )
    }

    componentDidMount() {
        this.handleSearch();

    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_hsbPayChannel_findHsbPayChannelConfigClrgRulePage, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }


    handleDelete = (id) => { //删除

        this.setState({ loading: true });
        let data = { id: id };
        post({
            url: config.API_hsbPayChannel_deletedHsbPayChannelConfigClrgRule,
            data,
        }).then(res => {
            this.setState({ loading: false });
            this.handleSearch();
            message.success(`删除成功`);
        }).catch(err => {
            message.error(err.message || '接口异常');
            this.setState({ loading: false });
        })
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true });
        this.ListAddRef.loadPack({ id });
        this.ListAddRef.initPack();
    }

    handlePayorderDetailListRef =(id) =>{
        this.PayorderDetailListModalRef.open(id);
    }

    handleQueryActionRecords = (id) => { //操作日志
        this.setState({ actionVisible: true });
        this.onAction.queryActionRecords({ rowId:id, tableName: "hsbPayChannelConfigClrgRule" });
    }

    handleHsbMarketPlatformRuleDetailRef =(id) =>{
        this.HsbMarketPlatformRuleDetailRef.open(id);
    }


    handleEditStatus=(id,status) =>{
        post({ url: config.API_hsbPayChannel_updateHsbPayChannelConfigClrgRuleStatus, data: { status, id } }).then(res => {
            message.success('操作成功');
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
}

const searchData = () => [

    {
        tagName: 'Select',
        formConfig: { name: 'executionCycle' },
        attribute: { placeholder: '执行周期', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicExecutionCycle),
        notResult: '',
    },
    {
        tagName: 'Select',
        formConfig: { name: 'clrgRuleType' },
        attribute: { placeholder: '费用类型', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicClrgRuleType),
        notResult: '',
    },
    {
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择启用状态', style: { width: '160px' } },
        optionData: [{ title: '全部', value: '' }].concat(hsbPayClrgRuleStatus),
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'shortName' },
        attribute: { placeholder: '输入商户名称', style: { width: '160px' } },
        title: '查询商户名称及简称模糊查询'
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: '在支付渠道名称及分账规则编号内模糊查询'
    },

];

const columns = ({ handleEdit , handleEditStatus,handleDelete,handlePayorderDetailListRef,handleHsbMarketPlatformRuleDetailRef,handleQueryActionRecords}) => [
    {
        title: '商户简称',
        dataIndex: 'shortName',
    },
    {
        title: '执行周期',
        dataIndex: 'executionCycle'
        ,render(text, record, index) {
            if(text) {
                let now = dicExecutionCycle.find(item => item.value === text);
                if (now)
                    return <span>{now.title}</span>;
            }
            return null
        },
    },
    {
        title: '周期开始日期',
        dataIndex: 'startDate'
        ,render(text, record, index) {
            if(text) {
                return <span>{ formatTime(text, "YYYY-MM-DD")}</span>;
            }
            return null
        },
    },
    {
        title: '周期截止日期',
        dataIndex: 'endDate'
        ,render(text, record, index) {
            if(text) {
                return <span>{ formatTime(text, "YYYY-MM-DD")}</span>;
            }
            return null
        },
    },
    {
        title: '汇集截止日期',
        dataIndex: 'collectionEndDate'
        ,render(text, record, index) {
            if(text) {
                return <span>{ formatTime(text, "YYYY-MM-DD")}</span>;
            }else{
                return <span>不限制</span>;
            }

        },
    },
    {
        title: '支付渠道名称',
        dataIndex: 'hsbPayChannelConfigName',
    },
    {
        title: '分账规则名称',
        dataIndex: 'clrgRuleName',render(text, record, index) {
        return <a onClick={() => handleHsbMarketPlatformRuleDetailRef(record.accountingRulesId)}>{text}</a>
    },
    },
    {
        title: '分账规则编号',
        dataIndex: 'clrgRuleId',

    },
    {
        title: '费用类型',
        dataIndex: 'clrgRuleType'
        ,render(text, record, index) {
            let now = dicClrgRuleType.find(item => item.value === text);
            if (now)
                return <span>{now.title}</span>;
            return null
        },
    },
    {
        title: '启用状态',
        dataIndex: 'status',
        render(text){
            if(text){
                let now = hsbPayClrgRuleStatus.find(item => item.value === text);
                if (now)
                    return <span>{now.title}</span>;
            }else{
                return "";
            }
        }
    },
    {
        title: '应汇集金额',
        dataIndex: 'totalMoney',
    }, {
        title: '已汇集金额',
        dataIndex: 'pooledAmount',render(text, record, index) {
            return <a onClick={() => handlePayorderDetailListRef(record.id)}>{text}</a>
        },
    },
    {
        title: '尚欠汇集金额',
        dataIndex: 'outstandingCollectionAmount'
    },
    {
        title: '是否允许超出上限/上限金额',
        dataIndex: 'upperLimit',
        render(text, record, index) {
            return <span>
                <div>{record.upperLimit?(record.upperLimit===1?"允许":'不允许'):'不允许'}</div>

                <div>{record.upperLimit?(record.upperLimit===1?record.upperLimitMoney:''):''}</div>
            </span>
        }
    },
    {
        title: '执行顺序',
        dataIndex: 'executionSequence',
    },
    {
        title: '更新时间',
        dataIndex: 'updateTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        render(text, record, index) {
            return (
                <React.Fragment>
                <AuthButton authkey="j-6-2">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-6-4">
                    <Popconfirm
                        placement="topRight"
                        title={record.status===2?'此分账规则确认启用吗?':'此分账规则确认禁用吗?'}
                        onConfirm={() => {

                            handleEditStatus(record.id, record.status===2?1:2);
                        }}
                        okText={record.status===2?'启用':'禁用'}
                        cancelText="取消"
                    >
                        <span className="showClickDetail" >{record.status===2?'启用':'禁用'}</span>
                    </Popconfirm>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-6-3">
                    <Popconfirm placement="top" title={"确定删除吗？"} onConfirm={() => { handleDelete(record.id) }} okText="确定" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                    <Divider type="vertical" />
                </AuthButton>
                <AuthButton authkey="j-6-5">
                    <span className="showClickDetail" onClick={() => { handleQueryActionRecords(record.id) }}>操作记录</span>
                </AuthButton>
                </React.Fragment>
                    )

        }
    },
];



// WEBPACK FOOTER //
// ./src/page/HsbPayClrgRule/List.js